import { Reveal, Rise } from "./Reveal";
import content from "../content";
import { SectionBg } from "./SectionBg";
import { scrollToId } from "../lib/scrollTo";

const TimePill = ({ t }) =>
  typeof t === "string" ? (
    <span className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-4 py-2 font-poppins text-sm text-white">
      {t}
    </span>
  ) : (
    <button
      type="button"
      onClick={() => t.link && scrollToId(t.link)}
      data-testid="schedule-featured-time"
      className="inline-flex items-center gap-2 rounded-full border border-electric bg-electric/20 pl-4 pr-1.5 py-1.5 font-poppins text-sm font-semibold text-white shadow-[0_0_22px_rgba(33,112,232,0.45)] transition-colors duration-300 hover:bg-electric cursor-pointer"
    >
      {t.time}
      <span className="rounded-full bg-electric px-2.5 py-1 text-[10px] uppercase tracking-[0.14em]">{t.tag}</span>
    </button>
  );

export default function ScheduleSection() {
  const { schedule } = content;

  return (
    <section id="horario" className="relative w-full bg-navy py-28 md:py-40 overflow-hidden" data-testid="schedule-section">
      <SectionBg image="/images/serve-new1.webp" tint="navy" />
      <div className="relative w-full max-w-7xl mx-auto px-6">
        <Reveal className="max-w-3xl">
          <Rise>
            <p className="eyebrow mb-5">{schedule.eyebrow}</p>
          </Rise>
          <Rise>
            <h2 className="display text-white text-[clamp(2.5rem,7vw,5.5rem)] mb-8">
              Nuestra semana<span className="text-electric">.</span>
            </h2>
          </Rise>
          <Rise>
            <p className="font-poppins text-ceramic/80 text-base md:text-lg leading-relaxed max-w-2xl">
              {schedule.intro}
            </p>
          </Rise>
        </Reveal>

        <Reveal className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-14" amount={0.15}>
          {schedule.days.map((d, i) => (
            <Rise key={d.day}>
              <article
                className="glass card-sweep relative overflow-hidden p-7 md:p-8 h-full group"
                data-testid={`schedule-card-${i}`}
              >
                <div className="absolute -right-8 -top-10 w-32 h-32 rounded-full bg-electric/20 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <h3 className="display text-white text-3xl md:text-4xl">{d.day}</h3>
                <p className="font-poppins text-electric text-sm tracking-wide uppercase mt-2 mb-6">
                  {d.detail}
                </p>
                <div className="flex flex-wrap gap-2">
                  {d.times.map((t) => (
                    <TimePill key={t.time || t} t={t} />
                  ))}
                </div>
              </article>
            </Rise>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
